import React from 'react';

const Modal = ({title, body, buttons, positionY = 'items-center'}) => {
    return <div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div className="fixed inset-0 bg-surface-950/70 backdrop-blur-md transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className={`flex min-h-full ${positionY} justify-center p-4 text-center sm:items-center sm:p-0`}>
            <div className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-2xl transition-all sm:my-8 sm:w-full sm:max-w-lg border border-surface-100">
                <div className="bg-white px-6 pb-5 pt-6 sm:p-8 sm:pb-5">
                <div className="w-full">
                    {title && <h3 className="text-xl font-bold text-surface-900 mb-4" id="modal-title">{title}</h3>}
                    <div>{body}</div>
                </div>
                </div>
                <div className="bg-surface-50 px-6 py-4 sm:flex sm:flex-row-reverse sm:px-8 border-t border-surface-100 gap-3">
                    {buttons}
                </div>
            </div>
            </div>
        </div>
    </div>
};

export default Modal;
